module.exports = __webpack_public_path__ + "img/JgIndex1.cc7f451a.png";